export default {
  numberInvoicesInCollection: {
    asc: 'numberInvoicesInCollection_ASC',
    desc: 'numberInvoicesInCollection_DESC',
  },
  firstName: {
    asc: 'firstName_ASC',
    desc: 'firstName_DESC',
  },
  lastName: {
    asc: 'lastName_ASC',
    desc: 'lastName_DESC',
  },
};
